export enum LinkTypeEnum {
  IMAGE = 'img',
  LINK = 'link',
  LINK_SERVICE ='link-service'
}
